import PropTypes from 'prop-types';
import React from 'react';
import cn from 'classnames';

export default function SelectDivider({ className }) {
  return (
    <option className={cn('cp-select-divider', className)} disabled aria-hidden>
      ────────────
    </option>
  );
}

SelectDivider.propTypes = {
  className: PropTypes.string
};
